import FormattedMessage from 'I18n/components/FormattedMessage';
import { CustomError } from 'pricing-pages-lib/errors/CustomErrors';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import Raven from 'raven-js';
import { useMemo } from 'react';
import { HUBSPOT_CREDITS_CARD } from '../../constants/tracking/TrackingSources';
import { useCalculatedPrice } from '../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { AddOnCardPricingFallback } from './AddOnCardFallbacks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubSpotCreditsPricing = ({
  productConfigurations,
  skuId,
  term
}) => {
  const currencyCode = useDisplayedCurrencyCode();
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const {
    monthlyCalculatedPrice,
    loading,
    error
  } = useCalculatedPrice({
    apiName: product.apiName,
    queryParamTerm: term
  });
  const price = useMemo(() => {
    var _productConfiguration, _productConfiguration2;
    const selectedQuantity = (_productConfiguration = (_productConfiguration2 = productConfigurations.find(config => config.skuId === skuId)) === null || _productConfiguration2 === void 0 ? void 0 : _productConfiguration2.quantity) !== null && _productConfiguration !== void 0 ? _productConfiguration : 1;
    if (!monthlyCalculatedPrice) {
      Raven.captureException(new CustomError('HubSpotCreditsPricing: No pricing data found for product', {
        error
      }));
      return null;
    }
    return monthlyCalculatedPrice * selectedQuantity;
  }, [monthlyCalculatedPrice, productConfigurations, skuId, error]);
  if (!price && !loading) {
    return /*#__PURE__*/_jsx(AddOnCardPricingFallback, {});
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [20],
    widths: ['100%'],
    children: price && /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": `${HUBSPOT_CREDITS_CARD}-${product.apiName}-price`,
      children: [/*#__PURE__*/_jsx(PriceDisplay, {
        price: price,
        currencyCode: currencyCode
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.priceDisplay.perMonth"
      })]
    })
  });
};